import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import styles from './Loading.module.scss';

interface LoadingProps {
  open?: boolean;
  backgroundColor?: string;
}

const Loading: React.FC<LoadingProps> = ({
  open = false,
  backgroundColor = 'rgba(255, 255, 255, 0.8)',
}) => {
  if (!open) return null;

  return (
    <Box
      className={styles.loadingContainer}
      style={{ backgroundColor: backgroundColor }}
    >
      <CircularProgress />
    </Box>
  );
};

export default Loading;
